<div class="step-container conclusao">
  <div class="celebracao">
    <div class="icone-celebracao">
      <i class="fe-check-circle"></i>
    </div>
    <h2 class="step-titulo text-center">Tudo pronto!</h2>
    <p class="step-subtitulo text-center">Sua loja está configurada e pronta para receber clientes.</p>
  </div>

  <!-- Preview -->
  <div class="preview-card" *ngIf="state.nomeEmpresa">
    <div class="preview-header">
      <div class="preview-logo" *ngIf="state.logoUrl || empresa.logo">
        <img [src]="'/images/empresa/' + (state.logoUrl || empresa.logo)" alt="Logo">
      </div>
      <div class="preview-logo-iniciais" *ngIf="!state.logoUrl && !empresa.logo">
        {{ state.nomeEmpresa.charAt(0) }}
      </div>
      <div class="preview-info">
        <strong>{{ state.nomeEmpresa }}</strong>
        <span *ngIf="state.subdominio">{{ state.subdominio }}.meucardapio.ai</span>
      </div>
    </div>
  </div>

  <!-- Checklist -->
  <div class="checklist">
    <div class="checklist-item" *ngFor="let item of checklist">
      <i class="fe-check-circle" [class.feito]="item.feito" [class.pendente]="!item.feito"></i>
      <span [class.text-muted]="!item.feito">{{ item.label }}</span>
    </div>
  </div>

  <!-- Botão principal -->
  <div class="text-center mt-4">
    <button class="btn-concluir" (click)="concluir()">
      Ir para o Painel <i class="fe-arrow-right ml-1"></i>
    </button>
  </div>

  <!-- Próximos passos -->
  <div class="proximos-passos mt-4">
    <h4 class="proximos-titulo">Próximos passos</h4>
    <ul class="proximos-lista">
      <li *ngFor="let passo of proximosPassos">{{ passo }}</li>
    </ul>
  </div>
</div>
